module.exports = __webpack_public_path__ + "static/media/06_avatar_male.19047a6c.png";